import React from 'react';
import MessageContent from '../../messageContent';
import { AVATAR_SRC } from '../constants';
import { formatMessageTime, getMessageMeta, isErrorLike } from '../messageUtils';

export default function ChatMessage({ message, messages, index }) {
  const meta = getMessageMeta(messages, index);
  const isError = message.isError || isErrorLike(message.content);
  const isUser = message.role === 'user';

  return (
    <div
      className={[
        'message-row',
        isUser ? 'user-message' : 'assistant-message',
        meta.compactTop ? 'message-row--compact' : '',
        isError ? 'message-row--error' : ''
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }}
    >
      {!isUser && (
        <div
          className={`message-avatar${meta.showAvatar ? '' : ' message-avatar--placeholder'}`}
          aria-hidden="true"
        >
          {meta.showAvatar && <img src={AVATAR_SRC} alt="" decoding="async" />}
        </div>
      )}
      <div className="message-stack">
        <div className={`message-content${isError ? ' message-content--error' : ''}`}>
          <MessageContent content={message.content} />
        </div>
        {meta.showTimestamp && (
          <div className="message-timestamp">{formatMessageTime(message.timestamp)}</div>
        )}
      </div>
    </div>
  );
}
